import {MODULE_BASE_URL} from '../config';

export default class XMLTransform {

    constructor(xml, pageName, moduleURL, assetID) {
        if (!xml) {
            throw Error('JRE: root node must be provided.');
        }
        if (!pageName) {
            throw Error('JRE: pageName cannot be empty.');
        }
        if (!moduleURL) {
            throw Error('JRE: module URL cannot be empty.');
        }
        const pageNode = xml.childNamed('page_node');
        if (!pageNode) {
            throw Error('JRE: page node must exist.');
        }

        this.xml = xml;
        this.pageNode = pageNode;
        this.pageName = pageName;
        this.moduleURL = moduleURL;
        this.assetID = assetID;

        // const moduleAsset = moduleURL.replace(`${MODULE_BASE_URL}/`, '');
        
        try {
            this.transformer = require(`../transformers/${assetID}.js`);
        } catch (err) {
            // No transformation file exists. Do nothing.
            this.transformer = null;
        }

    }

    findNodeById(id, currentNode) {
        /*
        Recursively find the node with the ID we're looking for.
         */
        let i, currentChild, result;

        if (currentNode.hasOwnProperty('attr') && currentNode.attr.hasOwnProperty('id') &&
            currentNode.attr.id === id) {
            return currentNode;
        } else {
            if (currentNode.hasOwnProperty('children')) {
                for (i = 0; i < currentNode.children.length; i++) {
                    currentChild = currentNode.children[i];
                    result = this.findNodeById(id, currentChild);
                    if (result !== false) {
                        return result;
                    }
                }
            }
            return false;
        }
    }

    transform() {
        if (!this.transformer) {
            return false;
        }
        if (!this.transformer.hasOwnProperty('default') ||
            !this.transformer.default.hasOwnProperty('pages')) {
            throw Error('JRE: a transformer file exists but it\'s empty or malformed.');
        }
        const currentPage = this.transformer.default.pages[this.pageName.toString().trim()] || [];
        currentPage.map(transformerNode => {
            const targetNodeID = transformerNode.id;
            let targetNode = this.findNodeById(targetNodeID, this.pageNode);
            if (targetNode) {
                transformerNode.attributes.map(attribute => {
                    targetNode.attr[attribute.name] = attribute.value;
                });
            } else {
                throw Error(`JRE: target node with ID ${targetNodeID} was not found.`);
            }
        });

        return this.xml;
    }

}



// WEBPACK FOOTER //
// ./src/js/utilities/xml-transform.js